import React from "react";
import { FaListAlt, FaBookOpen, FaBrain, FaUserTie } from "react-icons/fa";
import { motion } from "framer-motion";

const courses = [
  {
    id: 1,
    title: "Prelims Coaching",
    description:
      "Comprehensive preparation for General Studies Paper I & II (CSAT) with mock tests and in-depth coverage.",
    icon: <FaListAlt size={32} />,
    watermark: <FaListAlt size={120} />,
    bg: "bg-blue-50",
    textAccent: "text-blue-700",
    watermarkColor: "text-blue-200/40",
  },
  {
    id: 2,
    title: "Mains Coaching",
    description:
      "Detailed guidance for Essay, GS I–IV, and Ethics papers with daily answer writing practice and mentorship.",
    icon: <FaBookOpen size={32} />,
    watermark: <FaBookOpen size={120} />,
    bg: "bg-red-50",
    textAccent: "text-red-700",
    watermarkColor: "text-red-200/40",
  },
  {
    id: 3,
    title: "Optional Subjects",
    description:
      "Expert faculty for popular optional subjects like Sociology, Geography, Anthropology, PSIR, and more.",
    icon: <FaBrain size={32} />,
    watermark: <FaBrain size={120} />,
    bg: "bg-green-50",
    textAccent: "text-green-700",
    watermarkColor: "text-green-200/40",
  },
  {
    id: 4,
    title: "Interview Guidance",
    description:
      "One-on-one personality development sessions, mock interviews by retired bureaucrats, and DAF analysis.",
    icon: <FaUserTie size={32} />,
    watermark: <FaUserTie size={120} />,
    bg: "bg-purple-50",
    textAccent: "text-purple-700",
    watermarkColor: "text-purple-200/40",
  },
];

const Courses = () => {
  return (
    <section className="w-full bg-white py-24 px-6 md:px-16 relative overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Title */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-blue-50 border border-blue-100 text-[#1a237e] text-sm font-bold tracking-wider uppercase shadow-sm">
            Our Offerings
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight">
            Courses / <span className="text-blue-700">Programs Offered</span>
          </h2>
        </motion.div>

        {/* Soft Colored Blocks Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {courses.map((item, index) => (
            <motion.div
              key={item.id}
              className={`group relative flex flex-col p-8 rounded-[2rem] overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-slate-200/50 ${item.bg}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                ease: "easeOut",
                delay: index * 0.15,
              }}
              viewport={{ once: true }}
            >
              {/* Large Watermark Icon */}
              <div className={`absolute -bottom-6 -right-6 ${item.watermarkColor} transform -rotate-12 pointer-events-none transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-0`}>
                {item.watermark}
              </div>

              {/* Header: Icon */}
              <div className="flex justify-between items-start mb-8 relative z-10">
                <div className={`${item.textAccent}`}>
                  {item.icon}
                </div>
                <span className={`text-4xl font-black opacity-20 ${item.textAccent}`}>
                  0{item.id}
                </span>
              </div>

              {/* Content */}
              <div className="relative z-10 flex-grow">
                <h3 className="font-extrabold text-gray-900 text-2xl mb-4 group-hover:text-blue-800 transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-700 text-base font-medium leading-relaxed">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Courses;
